// @flow
import { all } from 'redux-saga/effects';

import authSaga from './auth/saga';
import layoutSaga from './layout/saga';
import ordersSaga from './orders/saga';
import shipmentsSaga from './shipments/saga';
import adjustmentsSaga from './adjustments/saga';
import manifestsSaga from './manifests/saga';
import integrationsSaga from './integrations/saga';
import editOrderSaga from './edit-order/saga';
import viewOrderSaga from './view-order/saga';
import newOrderSaga from './new-order/saga';
import addressBookSaga from './addressbook/saga';
import manifestSaga from './manifest/saga';
import profileSaga from './profile2/sagas';
import localStorageSaga from './local-storage/saga';
import packageItemsSaga from './package-items/saga';
import packageSaga from './package/saga';
import billingModalSaga from './billing-modal/saga';
import billingSaga from './billing/saga';
import integrationErrorsSaga from './integration-errors/saga';
import agentsSaga from './agents/saga';
import automationSaga from './automation/saga';
import { navigateErrorSaga } from './navigate-error/saga';
import packageSettingsSaga from './package-settings/saga';
import carrierSaga from './carrier/saga';
import labelSettingsSaga from './labels-docs-settings/saga';
import invitationSaga from './invitation/saga';
import batchesSaga from './batches/saga';
import orderBatchErrorSaga from './order-batch-errors/saga';
import productsSaga from './products/saga';
import commerceShipConnectorsSaga from './commerceship-connectors/saga';
import squareConnectorsSaga from './square-connectors/saga';
import orderAnalyticsSaga from './order-analytics/saga';
import weatherImpactSaga from './weather-impact/saga';
import shipmentsKpisSaga from './shipments-kpis/saga';
import savingsKpisSaga from './savings-kpis/saga';
import zonesKpisSaga from './zones-kpis/saga';
import rateSetsSaga from './rate-sets/saga';
import scenarioOptimizationsSaga from './scenario-optimizations/saga';
import surchargesOptimizationsSaga from './surcharges-optimizations/saga';
import totalCostOptimizationsSaga from './total-cost-optimizations/saga';
import serviceLevelsKpisSaga from './service-levels-kpis/saga';
import surchargesKpisSaga from './surcharges-kpis/saga';
import warehouseSaga from './warehouses/saga';
import locationsSaga from './locations/saga';
import inventorySaga from './inventory/saga';
import ratingJobsSaga from './rating-jobs/saga';
import integrationTypesSaga from './integration-types/saga';
import trackingStatusAnalyticsSaga from './tracking-status-analytics/saga';
import transitTimesAnalyticsSaga from './transit-times-analytics/saga';
import deliveryPerformanceAnalyticsSaga from './delivery-performance-analytics/saga';
import trackingReportsSaga from './tracking-reports/saga';
import trackingEventsSaga from './tracking-events/saga';
import shipmentTrackingRecordsSaga from './shipment-tracking-records/saga';
import integrationSummaryAnalyticsSaga from './integration-summary-analytics/saga';
import carrierOptimizationsSaga from './carrier-optimizations/saga';
import operationalOptimizationsSaga from './operational-optimizations/saga';
import usersSaga from './users/saga';
import financialsKpisSaga from './financials-kpis/saga';
import adjustmentJobsSaga from './adjustment-jobs/saga';
import syncJobsSaga from './sync-jobs/saga';
import apiKeysSaga from './api-keys/saga';
import activityLogSaga from './activity-log/saga';
import jobsSaga from './jobs/saga';

export default function* rootSaga() {
    yield all([
        authSaga(),
        layoutSaga(),
        ordersSaga(),
        shipmentsSaga(),
        activityLogSaga(),
        adjustmentsSaga(),
        integrationsSaga(),
        editOrderSaga(),
        viewOrderSaga(),
        newOrderSaga(),
        addressBookSaga(),
        manifestsSaga(),
        manifestSaga(),
        profileSaga(),
        localStorageSaga(),
        packageItemsSaga(),
        packageSaga(),
        integrationErrorsSaga(),
        navigateErrorSaga(),
        billingModalSaga(),
        billingSaga(),
        packageSettingsSaga(),
        billingSaga(),
        agentsSaga(),
        carrierSaga(),
        automationSaga(),
        labelSettingsSaga(),
        invitationSaga(),
        batchesSaga(),
        orderBatchErrorSaga(),
        productsSaga(),
        commerceShipConnectorsSaga(),
        squareConnectorsSaga(),
        orderAnalyticsSaga(),
        weatherImpactSaga(),
        shipmentsKpisSaga(),
        savingsKpisSaga(),
        zonesKpisSaga(),
        rateSetsSaga(),
        scenarioOptimizationsSaga(),
        surchargesOptimizationsSaga(),
        totalCostOptimizationsSaga(),
        serviceLevelsKpisSaga(),
        surchargesKpisSaga(),
        warehouseSaga(),
        locationsSaga(),
        inventorySaga(),
        ratingJobsSaga(),
        integrationTypesSaga(),
        trackingStatusAnalyticsSaga(),
        transitTimesAnalyticsSaga(),
        deliveryPerformanceAnalyticsSaga(),
        trackingReportsSaga(),
        trackingEventsSaga(),
        shipmentTrackingRecordsSaga(),
        integrationSummaryAnalyticsSaga(),
        carrierOptimizationsSaga(),
        operationalOptimizationsSaga(),
        usersSaga(),
        financialsKpisSaga(),
        adjustmentJobsSaga(),
        syncJobsSaga(),
        apiKeysSaga(),
        jobsSaga(),
    ]);
}
